/*

 _      _       _    _                _
| |    (_)     | |  | |              | |
| |     _ _ __ | | _| |     ___   ___| | _____ _ __
| |    | | '_ \| |/ | |    / _ \ / __| |/ / _ | '__|
| |____| | | | |   <| |___| (_) | (__|   |  __| |
|______|_|_| |_|_|\_|______\___/ \___|_|\_\___|_|

=======================*============================

main.js

*/

// Register service worker
if (navigator && navigator.serviceWorker) {
  navigator.serviceWorker.register('/serviceWorker.js?' + swVersion());
}

// Pre-fills the clipper with Title, URL, and selected text
// from user's current Web page
if (document.querySelector('#clipper-container')) {
  window.addEventListener('load', () => {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });

    document.getElementById('link').value = params.link;
    document.getElementById('title').value = params.title;
    document.getElementById('description').value = params.description;
  });
}

// Displays notifications for any Flask Flashes
window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.flashes')) {
    for (let message of document.querySelectorAll('.flashes li')) {
      let additionalClass = '';
      let input = {};

      const notificationCategories = [
        'error',
        'info',
        'warning',
        'success',
        'message',
      ];

      for (let category of notificationCategories) {
        if (message.classList.contains(category)) {
          additionalClass = category;
          input = {
            title: category.toUpperCase(),
            text: message.innerText,
          };
        }
      }

      let alert = new LLBrowserNotification(input, additionalClass);
      alert.doNotCloseAutomatically = true;
      alert.showNotification();
    }
  }
});

// Sets focus to search input on page load
window.addEventListener('DOMContentLoaded', () => {
  if (document.forms.entry) {
    if (document.getElementById('clipentry_header')) {
      document.forms.entry.tags.focus();
    } else {
      document.forms.entry.link.focus();
    }
  } else if (document.forms.search) {
    document.forms.search.query.focus();
  } else {
    return;
  }
});

// Toggles menu visibility

if (document.getElementById('menu-button')) {
  document.getElementById('menu-button').addEventListener('click', () => {
    var menuList = document.getElementById('nav');
    var mobileNav = document.getElementById('mobile-nav');
    if (mobileNav.innerHTML === '') {
      mobileNav.innerHTML = menuList.innerHTML;
    } else {
      mobileNav.innerHTML = '';
    }
  });
}

/////// Init Modals ///////

// CSRF Error Modal

// open model on aforesaid event
document.addEventListener('csrf-error', () => {
  // instantiate & build element
  let csrfModal = new Modal(appSettings.modals.csrfModal);
  csrfModal.addModal();
  // open modal
  csrfModal.makeVisible();
});

// Data Export Modal

// Init modal only if link with specified ID is present
document.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('export-link')) {
    // instantiate & build element
    let exportModal = new Modal(appSettings.modals.exportModal);
    exportModal.addModal();
    // click handler that opens the modal
    document.getElementById('export-link').addEventListener('click', (e) => {
      e.preventDefault();
      exportModal.makeVisible();
    });
  }
});

/////// END MODALS INIT ///////

// Toggles stars.

function setStar(i) {
  var httpRequest = new XMLHttpRequest();
  var csrftoken = appSettings.csrfToken;
  // when the response is received
  httpRequest.onload = function () {
    if (JSON.parse(httpRequest.responseText)['error']) {
      // throw error
      document.dispatchEvent(appSettings.customEvents.csrfError);
    } else {
      // toggle the star in the client
      toggleStar(httpRequest.responseText);
    }
  };
  var stUrl = '/toggle-star/' + i + '?origin=ajax';
  httpRequest.open('POST', stUrl, true);
  httpRequest.setRequestHeader('X-CSRFToken', csrftoken);
  httpRequest.send();
}

function toggleStar(response) {
  obj = JSON.parse(response);
  var i = obj.id;
  var star = obj.starred;
  var replacer = '';
  if (star == true) {
    replacer = '\u2605';
  } else if (star == false) {
    replacer = '\u2606';
  }
  document.getElementById('star-' + i).innerHTML = replacer;
}

// Toggles Read Later status.

const setReadLaterEventListeners = () => {
  for (let readLink of document.querySelectorAll('.mark-read')) {
    readLink.addEventListener('click', (event) => {
      event.preventDefault();
      let i = event.target.parentNode.id.split('-')[1];
      let httpRequest = new XMLHttpRequest();
      let csrftoken = appSettings.csrfToken;
      httpRequest.onload = function () {
        // when the response is received
        if (JSON.parse(httpRequest.responseText)['error']) {
          // throw error
          document.dispatchEvent(appSettings.customEvents.csrfError);
        } else {
          // toggle the read status
          let obj = JSON.parse(httpRequest.responseText);
          let i = obj.id;
          document
            .getElementById('link-' + i)
            .classList.remove('readlater-link');
          event.target.parentNode.parentNode.removeChild(
            event.target.parentNode
          );
        }
      };
      let stUrl = '/toggle-read/' + i + '?origin=ajax';
      httpRequest.open('POST', stUrl, true);
      httpRequest.setRequestHeader('X-CSRFToken', csrftoken);
      httpRequest.send();
    });
  }
};

setReadLaterEventListeners();

// Edits link.

function showEditForm(i) {
  var httpRequest = new XMLHttpRequest();
  httpRequest.onload = function () {
    if (JSON.parse(httpRequest.responseText)['error']) {
      // throw error
      document.dispatchEvent(appSettings.customEvents.csrfError);
    } else {
      // when the response is received
      populateEditForm(httpRequest.responseText); // fill the form
      // Some stuff to make tag suggestions work
      document.forms.activeEditor.edit_tags.addEventListener(
        'input',
        suggestTags
      );
      document.forms.activeEditor.edit_tags.addEventListener(
        'focus',
        commaHelper
      );
      document.forms.activeEditor.edit_tags.addEventListener(
        'blur',
        commaRemover
      );
      thisForm = document.forms.activeEditor.edit_tags;
      // Enable arrow-key nav functions
      go_tagField();
      go_suggMenu();
    }
  };
  var stUrl = '/get-link/' + i;
  var edit = document.getElementById('form_editor').innerHTML;
  var original = document.getElementById('link-' + i).innerHTML;
  // Stash original element
  if (document.getElementById('edit-temp').innerHTML === '') {
    document.getElementById('edit-temp').innerHTML = original;
  }
  // Insert edit form
  document.getElementById('link-' + i).innerHTML = edit;
  // Preload tags for autosuggest
  grabSuggTagsList();
  // Change its name to avoid DOM conflicts
  document.getElementById('editForm').name = 'activeEditor';
  httpRequest.open('GET', stUrl, true);
  httpRequest.send();
}

function populateEditForm(response) {
  obj = JSON.parse(response);
  var id = obj.id;
  var title = obj.title;
  var link = obj.link;
  var description = obj.description;
  var tags = obj.tags;
  var category = obj.category;
  document.getElementById('id').value = id;
  if (obj.starred == true) {
    document.getElementById('edit_starred').checked = true;
  } else {
    document.getElementById('edit_starred').checked = false;
  }

  if (obj.readlater == true) {
    document.getElementById('edit_readlater').checked = true;
  } else {
    document.getElementById('edit_readlater').checked = false;
  }
  document.getElementById('edit_category').value = category;
  document.getElementById('edit_title').value = title;
  document.getElementById('edit_link').value = link;
  document.getElementById('edit_description').value = description;
  if (tags != null) {
    document.getElementById('edit_tags').value = tags.join(', ');
  }
}

function killEdit() {
  const cancel_link = document.getElementById('cancel_link');
  const id =
    cancel_link.closest('.link-li').id ||
    cancel_link.parentNode.parentNode.parentNode.id;

  let original = document.getElementById('edit-temp').innerHTML;
  document.getElementById(id).innerHTML = original;
  original = '';

  setTimeout(() => {
    if (!linkEditorIsLive()) {
      document.dispatchEvent(appSettings.customEvents.fetchReadyEvent);
    }
  }, 75);
}

//Event listener
document.addEventListener('change', function () {
  function sendEditForm() {
    const httpRequest = new XMLHttpRequest();
    const FD = new FormData(form);

    httpRequest.addEventListener('load', function (event) {
      updateEditedLink(event.target.responseText);
    });

    httpRequest.addEventListener('error', function () {
      const message = appSettings.notifications.editError;
      const editErrorNotification = new LLBrowserNotification(message, 'error');
      editErrorNotification.showNotification();
    });

    const loc = window.location.href;
    const stUrl = loc;

    httpRequest.open('POST', stUrl);
    httpRequest.send(FD);

    return (() => {
      document.querySelector('#editForm input[name="submit"]').value =
        'Editing...';
      const formEL = this.form;
      const allElements = formEL.elements;
      for (let el of allElements) {
        el.disabled = true;
        el.style.opacity = 0.5;
      }
    })();
  }

  if ((form = document.getElementById('editForm'))) {
    let form = document.getElementById('editForm');
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      sendEditForm();
    });
  }
});

// Replace edit form with edited content
// OR display validation errors
function updateEditedLink(response) {
  const original = document.getElementById('edit-temp').innerHTML;
  const link_id = document
    .getElementById('editForm')
    .parentNode.id.split('-')[1];

  const getOriginal = () => {
    document.getElementById(link_id).innerHTML = original;
  };

  const obj = (() => {
    try {
      return JSON.parse(response);
    } catch (e) {
      console.warn(e);
      if (
        response.includes('<!DOCTYPE html>') &&
        response.includes('CSRF Error')
      ) {
        document.dispatchEvent(appSettings.customEvents.csrfError);
      } else {
        const message = appSettings.notifications.editError;
        const editErrorNotification = new LLBrowserNotification(
          message,
          'error'
        );
        editErrorNotification.showNotification();
      }
      return {
        error: e,
        id: 0,
      };
    }
  })();

  if (obj.id === link_id) {
    document.dispatchEvent(appSettings.customEvents.fetchReadyEvent);
  } else {
    // VALIDATION ERRORS //
    var idError = obj.id;
    var catError = obj.edit_category;
    var catTextError = obj.edit_category_text;
    var titleError = obj.edit_title;
    var linkError = obj.edit_link;
    var descriptionError = obj.edit_description;
    var tagsError = obj.edit_tags;
    if (idError) {
      idError = String(idError).split(',');
      var idErrorList = '';
      for (i in idError) {
        idErrorList += '<li>' + idError[i] + '</li>';
      }
      var idErrorDOM = document.getElementById('idError');
      idErrorDOM.style.display = 'inline';
      document.getElementById('idError').innerHTML = idErrorList;
    }
    if (catError) {
      catError = String(catError).split(',');
      var catErrorList = '';
      for (i in catError) {
        catErrorList += '<li>' + catError[i] + '</li>';
      }
      var catErrorDOM = document.getElementById('catError');
      catErrorDOM.style.display = 'inline';
      document.getElementById('catError').innerHTML = catErrorList;
    }
    if (catTextError) {
      catTextError = String(catTextError).split(',');
      var catTextErrorList = '';
      for (i in catTextError) {
        catTextErrorList += '<li>' + catTextError[i] + '</li>';
      }
      var catErrorDOM = document.getElementById('catError');
      catErrorDOM.style.display = 'inline';
      document.getElementById('catError').innerHTML = catTextErrorList;
    }
    if (titleError) {
      titleError = String(titleError).split(',');
      var titleErrorList = '';
      for (i in titleError) {
        titleErrorList += '<li>' + titleError[i] + '</li>';
      }
      var titleErrorDOM = document.getElementById('titleError');
      titleErrorDOM.style.display = 'inline';
      document.getElementById('titleError').innerHTML = titleErrorList;
    }
    if (titleError) {
      titleError = String(titleError).split(',');
      var titleErrorList = '';
      for (i in titleError) {
        titleErrorList += '<li>' + titleError[i] + '</li>';
      }
      var titleErrorDOM = document.getElementById('titleError');
      titleErrorDOM.style.display = 'inline';
      document.getElementById('titleError').innerHTML = titleErrorList;
    }
    if (linkError) {
      linkError = String(linkError).split(',');
      var linkErrorList = '';
      for (i in linkError) {
        linkErrorList += '<li>' + linkError[i] + '</li>';
      }
      var linkErrorDOM = document.getElementById('linkError');
      linkErrorDOM.style.display = 'inline';
      document.getElementById('linkError').innerHTML = linkErrorList;
    }
    if (descriptionError) {
      descriptionError = String(descriptionError).split(',');
      var descriptionErrorList = '';
      for (i in descriptionError) {
        descriptionErrorList += '<li>' + descriptionError[i] + '</li>';
      }
      var descriptionErrorDOM = document.getElementById('descriptionError');
      descriptionErrorDOM.style.display = 'inline';
      document.getElementById('descriptionError').innerHTML =
        descriptionErrorList;
    }
    if (tagsError) {
      tagsError = String(tagsError).split(',');
      var tagsErrorList = '';
      for (i in tagsError) {
        tagsErrorList += '<li>' + tagsError[i] + '</li>';
      }
      var tagsErrorDOM = document.getElementById('tagsError');
      tagsErrorDOM.style.display = 'inline';
      document.getElementById('tagsError').innerHTML = tagsErrorList;
    }
  }
}

// Show bulk edit controls

if (document.querySelector('#show-bulk-editor a')) {
  document
    .querySelector('#show-bulk-editor a')
    .addEventListener('click', function () {
      var linkControls = document.querySelectorAll('.bulk-edit-selector input');
      var displayStatus = document.querySelector('#bulk-edit-controls').style
        .display;
      if (!displayStatus || displayStatus === 'none') {
        this.innerHTML = 'HIDE BULK DELETE';
        document.querySelector('#bulk-edit-controls').style.display = 'flex';
        for (var i = 0; i < linkControls.length; i++) {
          linkControls[i].parentNode.style.display = 'block';
          linkControls[i].addEventListener('click', function () {
            if (this.checked) {
              document.querySelectorAll(
                '#bulk-edit-controls button'
              )[0].style.display = 'inline-block';
            }
          });
        }
        // hide any open edit forms
        killEdit();
      } else {
        this.innerHTML = 'BULK DELETE';
        document.querySelector('#bulk-edit-controls').style.display = 'none';
        for (var i = 0; i < linkControls.length; i++) {
          linkControls[i].parentNode.style.display = 'none';
        }
      }
    });
}

// Deletes link.

function deleteLinkConfirm(i) {
  let id = 'delete-confirmation-' + i;
  let anchor = document.getElementById(id);
  if (anchor.classList.contains('visible')) {
    anchor.onclick = anchor.classList.remove('visible');
    document.getElementById('delete-' + i).innerText = 'delete';
  } else {
    anchor.onclick = anchor.classList.add('visible');

    // handle closing of tooltip when clicking outside it
    // may want to abstract this for LLWA-T138
    (() => {
      const tooltip = document.querySelector('.delete-confirmation.visible');

      const setClickHandler = () => {
        document.addEventListener('click', (event) => {
          let isOuterButton = event.target.classList.contains('outer-delete');
          if (!tooltip.contains(event.target) && !isOuterButton) {
            tooltip.classList.remove('visible');
            document.getElementById('delete-' + i).innerText = 'delete';
          }
        });
      };

      document.addEventListener('click', setClickHandler());
      tooltip.parentElement.querySelector('.outer-delete').innerText = 'cancel';
    })();
  }
}

function deleteIt(i) {
  var csrftoken = appSettings.csrfToken;
  var httpRequest = new XMLHttpRequest();
  httpRequest.onload = function () {
    // when the response is received
    if (JSON.parse(httpRequest.responseText)['error']) {
      // throw error
      document.dispatchEvent(appSettings.customEvents.csrfError);
    } else {
      // show deletion confirmation
      deleteLinkUI(httpRequest.responseText);
    }
  };
  var stUrl = '/delete-link/' + i + '?origin=ajax';
  httpRequest.open('POST', stUrl, true);
  httpRequest.setRequestHeader('X-CSRFToken', csrftoken);
  httpRequest.send();
}

function deleteMultiLinks(linkObj) {
  var csrftoken = appSettings.csrfToken;
  var httpRequest = new XMLHttpRequest();
  var body = JSON.stringify(linkObj);
  httpRequest.onload = function () {
    // when the response is received
    if (JSON.parse(httpRequest.responseText)['error']) {
      // throw error
      document.dispatchEvent(appSettings.customEvents.csrfError);
    } else {
      // show deletion confirmation
      var obj = JSON.parse(httpRequest.responseText);
      for (var i = 0; i < obj.success_ids.length; i++) {
        var singleLinkResponse = {};
        singleLinkResponse.deleted = obj.deleted;
        singleLinkResponse.id = obj.success_ids[i];
        deleteLinkUI(singleLinkResponse);
      }
    }
  };
  var stUrl = '/delete-link?origin=ajax';
  httpRequest.open('POST', stUrl, true);
  httpRequest.setRequestHeader('X-CSRFToken', csrftoken);
  httpRequest.send(body);
}

function deleteLinkUI(response) {
  if (typeof response === 'string') {
    var obj = JSON.parse(response);
  } else {
    var obj = response;
  }
  var i = 'link-' + obj.id;
  var item = document.getElementById(i);
  var deleted = obj.deleted;
  document.getElementById(i).innerHTML =
    '<strong class="flashes">' + deleted + '</strong>';
  deleteLi = function () {
    item.remove(item);
    if (document.getElementById('notice')) {
      document.getElementById('notice').innerHTML = 'Link deleted.';
    }
  };
  setTimeout(deleteLi, 1250);
}

// bulk delete
if (document.querySelector('#bulk-delete-submit')) {
  document
    .querySelector('#bulk-delete-submit')
    .addEventListener('click', () => {
      const selected = document.querySelectorAll(
        '.bulk-edit-selector input:checked'
      );
      if (selected.length < 1) {
        alert('Nothing Selected');
      } else {
        // instantiate modal object
        let bulkDeletionModal = new Modal(appSettings.modals.bulkDeletionModal);

        // set clickHandler on the modal object
        bulkDeletionModal.data.clickHandler = () => {
          const reqBody = {};
          const idArray = [];
          const linkControls = document.querySelectorAll(
            '.bulk-edit-selector input'
          );
          for (let selection of selected) {
            const id = selection.id.split('bulk-edit-')[1];
            idArray.push(id);
          }
          reqBody['idArray'] = idArray;
          deleteMultiLinks(reqBody);
          document.querySelector('#bulk-edit-controls').style.display = 'none';
          bulkDeletionModal.makeInvisible();

          document.querySelector('#show-bulk-editor a').innerHTML =
            'BULK DELETE';
          for (let control of linkControls) {
            control.parentNode.style.display = 'none';
          }
        };

        // build element
        bulkDeletionModal.addModal();

        // open modal
        bulkDeletionModal.makeVisible();
      }
    });
}

// Display name of import file

function getImportFileName() {
  var fakepath = 'C:\\fakepath\\';
  var raquo = '&raquo; ';
  var file = document.getElementById('uploadSel').value;
  if (file.indexOf(fakepath) > -1) {
    var file = file.split(fakepath);
    document.getElementById('fileSelected').innerHTML = raquo + file[1];
  } else {
    document.getElementById('fileSelected').innerHTML = raquo + file;
  }
  var error = document.getElementById('file-error');
  error.parentElement.removeChild(error);
}

// Event listener for import filename display
if (document.getElementById('file-picker')) {
  document
    .getElementById('file-picker')
    .addEventListener('change', getImportFileName);
}

// Cancel Subscription

async function cancelSub() {
  loader();
  let csrftoken = appSettings.csrfToken;
  let subID = document
    .getElementById('cancelSubscription')
    .getAttribute('name');
  const stUrl = '/cancel/' + subID;

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': csrftoken,
    },
  };

  let request = await fetch(stUrl, options)
    .then((response) => response.text())
    .then((data) => {
      return data;
    });

  if (JSON.parse(request)['error']) {
    // throw error
    document.dispatchEvent(appSettings.customEvents.csrfError);
  } else {
    // cancel
    confirmCancel(request);
  }
}

function confirmCancel(response) {
  obj = JSON.parse(response);
  var messageDiv = document.getElementById('canceled');
  var canceled = obj.canceled;
  messageDiv.innerHTML = '<strong>' + canceled + '</strong>';
  setTimeout(function () {
    location.reload();
  }, 3000);
}

//Event listener for cancel button
if (document.getElementById('cancelSubscription')) {
  document
    .getElementById('cancelSubscription')
    .addEventListener('click', cancelSub);
}

// Revoke OAuth Grant

function revokeGrant(a) {
  var csrftoken = appSettings.csrfToken;
  var clientID = a.name;
  var params = 'client_id=' + encodeURIComponent(clientID);
  var httpRequest = new XMLHttpRequest();
  httpRequest.onload = function () {
    confirmRevoke(httpRequest.responseText);
  };
  var stUrl = '/oauth/revoke';
  httpRequest.open('POST', stUrl, true);
  httpRequest.setRequestHeader('X-CSRFToken', csrftoken);
  httpRequest.setRequestHeader(
    'Content-type',
    'application/x-www-form-urlencoded'
  );
  httpRequest.send(params);
}

function confirmRevoke(response) {
  obj = JSON.parse(response);
  var revocation = obj.revocation;
  item = document.getElementById('revoked');
  item.innerHTML = '<span class="alert">' + revocation + '</span>';
  removeRow = function () {
    item.parentNode.remove(item);
    if (document.getElementById('revoked')) {
      document.getElementById('revoked').innerHTML = 'Grant revoked.';
    }
    var grantTable = document.getElementById('grantTable');
    var removalMessage =
      '<p class="alert">All grants have been revoked.</span>';
    if (grantTable.rows.length < 1) {
      grantTable.outerHTML = removalMessage;
    }
  };
  setTimeout(removeRow, 1500);
}

//Event delegation for revocation buttons
if (document.addEventListener) {
  document.addEventListener('click', handleClick, false);
} else if (document.attachEvent) {
  document.attachEvent('onclick', handleClick);
}

function handleClick(event) {
  event = event || window.event;
  event.target = event.target || event.srcElement;

  var element = event.target;

  while (element) {
    if (element.nodeName === 'A' && /revoke/.test(element.className)) {
      // The user has clicked on an <a> with the class "revoke"
      var tableCell = element.parentNode;
      tableCell.id = 'revoked';
      revokeGrant(element);
      break;
    }

    element = element.parentNode;
  }
}

// Autosuggestions

var thisForm = '';

if (document.forms[1] == document.forms.entry) {
  try {
    thisForm = document.forms[1].tags;
  } catch (err) {
    thisForm = null;
  }
} else {
  thisForm = document.forms[0].tags;
}

function commaHelper() {
  // Call commaRemover so an extra comma won't be inserted
  // when the field regains focus from the autosuggestion list.
  commaRemover();
  var fieldValue = thisForm.value;
  if (fieldValue.length != 0) {
    try {
      document.forms.activeEditor.edit_tags.value = fieldValue + ', ';
    } catch (e) {}
    try {
      document.forms[0].tags.value = fieldValue + ', ';
    } catch (e) {}
    try {
      document.forms[1].tags.value = fieldValue + ', ';
    } catch (e) {}
  }
}

function commaRemover() {
  var fieldValue = thisForm.value;
  if (fieldValue.slice(-2) == ', ') {
    try {
      document.forms.activeEditor.edit_tags.value = fieldValue.slice(0, -2);
    } catch (e) {}
    try {
      document.forms[0].tags.value = fieldValue.slice(0, -2);
    } catch (e) {}
    try {
      document.forms[1].tags.value = fieldValue.slice(0, -2);
    } catch (e) {}
  } else if (fieldValue.slice(-1) == ',') {
    try {
      document.forms.activeEditor.edit_tags.value = fieldValue.slice(0, -1);
    } catch (e) {}
    try {
      document.forms[0].tags.value = fieldValue.slice(0, -1);
    } catch (e) {}
    try {
      document.forms[1].tags.value = fieldValue.slice(0, -1);
    } catch (e) {}
  }
}

function suggestTags() {
  var tagslist = appSettings.tagsList;
  var suggestions = [];
  var userInput = thisForm.value;
  if (userInput.match(',')) {
    if (userInput.match(', ')) {
      userInput = userInput.split(', ');
    } else {
      userInput = userInput.split(',');
    }
    userInput = userInput[userInput.length - 1];
  }
  if (userInput != '') {
    var re = new RegExp('(?:^|\\s)' + userInput, 'gi');
  } else {
    var re = null;
  }
  for (i = 0; i < tagslist.length; i++) {
    if (tagslist[i].match(re)) {
      sugg =
        '<li tabindex="0" class="suggestion" onclick="tagPick(\'' +
        tagslist[i] +
        "'" +
        ')" onkeypress=" javascript: if(event.keyCode == 13) tagPick(\'' +
        tagslist[i] +
        "'" +
        ')">' +
        tagslist[i] +
        '</li>';
      suggestions.push(sugg);
    }
  }
  if (suggestions) {
    suggestions = suggestions.slice(0, 5);
    document.getElementById('suggestions').innerHTML = suggestions.join('');
  }
}

// Arrow-key listener for tags form field
function go_tagField() {
  var tagfield = thisForm;
  tagfield.addEventListener('keydown', function (event) {
    if (event.keyCode == 40) {
      // Prevent down arrow from scrolling
      event.preventDefault();
      var suggestions = document.activeElement;
      var direction = 'forward';
      var nextEl = findNextTabStop(suggestions, direction);
      nextEl.focus();
    } else if (event.keyCode == 27) {
      // close autoauggestion UI on press of escape key
      document.getElementById('suggestions').innerHTML = '';
      thisForm.focus();
    }
  });
}

// Arrow-key listener for tags suggestion list UI
function go_suggMenu() {
  var suggMenu = document.getElementById('suggestions');
  suggMenu.addEventListener('keydown', function (event) {
    if (event.keyCode == 40) {
      // Prevent down arrow from scrolling
      event.preventDefault();
      var suggestion = document.activeElement;
      var direction = 'forward';
      var nextEl = findNextTabStop(suggestion, direction);
      nextEl.focus();
    } else if (event.keyCode == 38) {
      // Prevent up arrow from scrolling
      event.preventDefault();
      var suggestion = document.activeElement;
      var direction = 'back';
      var prevEl = findNextTabStop(suggestion, direction);
      prevEl.focus();
    }
  });
}

// Finds the next tabbable item
function findNextTabStop(el, direction) {
  var universe = document.querySelectorAll('li');
  var list = Array.prototype.filter.call(universe, function (item) {
    return item.tabIndex >= '0';
  });
  var index = list.indexOf(el);
  if (direction == 'forward') {
    return list[index + 1] || list[0];
  } else if (direction == 'back') {
    return list[index - 1] || list[0];
  }
}

// Pick tag and populate form with it
function tagPick(sugg) {
  var fieldValue = thisForm.value;
  if (fieldValue.match(',')) {
    fieldValue = fieldValue.split(',').slice(0, -1).join(',');
    thisForm.value = fieldValue + ', ' + sugg + ', ';
    thisForm.focus();
  } else {
    thisForm.value = sugg + ', ';
    thisForm.focus();
  }
  document.getElementById('suggestions').innerHTML = '';
}

//Event listeners for tags field (except in edit form, see `showEditForm`
if (document.getElementById('tags')) {
  document.getElementById('tags').addEventListener('input', suggestTags);
  document.getElementById('tags').addEventListener('focus', commaHelper);
  document.getElementById('tags').addEventListener('blur', commaRemover);
  // Enable arrow-key nav functions
  go_tagField();
  go_suggMenu();
}

// Grab Tagslist after page load - clipper and add new only
if (document.querySelector('#container.needs-tagslist')) {
  window.addEventListener('DOMContentLoaded', grabSuggTagsList());
}

// Grab Tagslist and set to global var
function grabSuggTagsList() {
  var httpRequest = new XMLHttpRequest();
  httpRequest.onload = function () {
    var list = JSON.parse(httpRequest.responseText);
    appSettings.tagsList = list;
  };
  var TAGSUrl = '/tag-suggestions';
  httpRequest.open('GET', TAGSUrl, true);
  httpRequest.setRequestHeader(
    'Content-type',
    'application/x-www-form-urlencoded'
  );
  httpRequest.send();
}

// Show input field for category in entry, clipper, editor

function toggleField(hideObj, showObj) {
  hideObj.disabled = true;
  hideObj.style.display = 'none';
  showObj.disabled = false;
  showObj.style.display = 'inline';
  showObj.focus();
}

// Show modal UI controls for category management
if (document.querySelector('.category-context-nav')) {
  document.querySelector('.rename-open').addEventListener('click', (e) => {
    e.preventDefault();
    let form = document.getElementById('rename-form');
    appSettings.modals.categories.catRenameModal.form = form.outerHTML;
    let catRenameModal = new FormModal(
      appSettings.modals.categories.catRenameModal
    );
    catRenameModal.addModal();
    // open modal
    catRenameModal.makeVisible();
  });

  document.querySelector('.move-open').addEventListener('click', (e) => {
    e.preventDefault();
    let form = document.getElementById('move-form');
    appSettings.modals.categories.catMoveModal.form = form.outerHTML;
    let catMoveModal = new FormModal(
      appSettings.modals.categories.catMoveModal
    );
    catMoveModal.addModal();
    // open modal
    catMoveModal.makeVisible();
  });

  document.querySelector('.create-open').addEventListener('click', (e) => {
    e.preventDefault();
    let form = document.getElementById('subcategory-form');
    appSettings.modals.categories.catCreateModal.form = form.outerHTML;
    let catCreateModal = new FormModal(
      appSettings.modals.categories.catCreateModal
    );
    catCreateModal.addModal();
    // open modal
    catCreateModal.makeVisible();
  });

  document.querySelector('.delete-open').addEventListener('click', (e) => {
    e.preventDefault();
    let catDeleteModal = new Modal(
      appSettings.modals.categories.catDeleteModal
    );
    catDeleteModal.addModal();
    // open modal
    catDeleteModal.makeVisible();
  });
}

function editCategory(form) {
  var httpRequest = new XMLHttpRequest();
  var FD = new FormData(form);
  httpRequest.addEventListener('load', function (event) {
    afterCategoryEdit(event.target.responseText);
  });
  httpRequest.addEventListener('error', function () {
    alert('Error: form data not sent.');
  });
  var stUrl = window.location.href;
  httpRequest.open('POST', stUrl);
  httpRequest.send(FD);
}

function afterCategoryEdit(response) {
  var obj = JSON.parse(response);
  if (obj.result) {
    var category = obj.result;
    window.open('/category/' + category, '_self');
  } else if (obj.error) {
    alert(obj.error);
    // Validation errors
  } else {
    if (obj.new_category) {
      var catEditError = obj.new_category;
      var errorListDOM = 'catRenameError';
    } else if (obj.new_subcategory) {
      var catEditError = obj.new_subcategory;
      var errorListDOM = 'catCreateError';
    } else if (obj.new_parent) {
      var catEditError = obj.new_parent;
      var errorListDOM = 'catMoveError';
    } else {
      alert(obj);
    }
    catEditError = String(catEditError).split(',');
    var catEditErrorList = '';
    for (i in catEditError) {
      catEditErrorList += '<li>' + catEditError[i] + '</li>';
    }
    var catEditErrorDOM = document.getElementById(errorListDOM);
    catEditErrorDOM.style.padding = '0';
    document.getElementById(errorListDOM).innerHTML = catEditErrorList;
  }
}

// Set Modal Cookie

function modalCookie() {
  cookie_name = 'LL_modal_viewed';
  var now = new Date();
  var time = now.getTime();
  time += 30 * 24 * 60 * 60 * 1000;
  now.setTime(time);
  if (document.cookie != document.cookie) {
    index = document.cookie.indexOf(cookie_name);
  } else {
    index = -1;
  }
  if (index == -1) {
    document.cookie = cookie_name + '=seen; expires=' + now.toUTCString();
  }
}

// Loading Indicator

// pass in a different number to alter timeout interval
const loader = (timeout = 10000) => {
  document.querySelector('.loader-parent').style.display = 'grid';
  document.body.style.overflow = 'hidden';

  // Will kill the loader if it's still running
  // after timeout in milliseconds
  setTimeout(() => {
    document.querySelector('.loader-parent').style.display = 'none';
    document.body.style.overflow = 'visible';
  }, timeout);
};

// update year in footer copyright statement -- making generic and extensible
// in case this ends up being useful later
if (document.querySelectorAll('.current-year')) {
  const elements = document.querySelectorAll('.current-year');
  for (let el of elements) {
    el.innerHTML = new Date().getFullYear();
  }
}

// Prevent default on all demo-link `a` tags
if (document.querySelector('.demo-link')) {
  document.querySelector('.demo-link').addEventListener('click', (event) => {
    event.preventDefault();
  });
}

// END //
